import { ArrowLeftIcon, ArrowRightIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React from 'react';
import { polymorphicFactory } from '../../../../factory/factory.utils.mjs';
import { Box } from '../../../../Other/Box/Box.mjs';
import classes from './CarouselControl.module.css.mjs';

const CarouselControl = polymorphicFactory(
  (props, ref) => {
    const { component = "button", className, direction, ...rest } = props;
    const classNames = clsx("kohler-carousel-control-root", className, classes.carouselControl);
    return /* @__PURE__ */ React.createElement(
      Box,
      {
        className: classNames,
        component,
        ref,
        type: component === "button" ? "button" : void 0,
        "aria-label": rest["aria-label"] || direction === "left" ? "carousel arrow left" : "carousel arrow right",
        ...rest
      },
      direction === "left" ? /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "medium" }) : /* @__PURE__ */ React.createElement(ArrowRightIcon, { size: "medium", withBoundingBox: false })
    );
  }
);

export { CarouselControl };
